import classNames from 'classnames'
import React from 'react'

import type { HTMLString } from '~/types/strapi'

type Properties = {
  html: HTMLString
} & React.BaseHTMLAttributes<HTMLDivElement>

const RichText: React.FC<Properties> = ({
  html = '',
  className = '',
  ...rest
}) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: html }}
      className={classNames(
        'prose gap-4 md:gap-5 prose-li:marker:!text-neutral-black prose-ul:marker:list-outside ',
        className
      )}
      {...rest}
    />
  )
}

export default RichText
